export default function (state, val) {
    let date = new Date();
    state.list.push({
        code: val,
        load: true,
        callback: [],
        sum: 0,
        course: 1,
        date: '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
        comment: '',
        contragents: [],
        legals: [],
        requests: [],
        startDate: '',
        country: '',
        CarryOverOfFunds: '',
    })
}
